import { ZAHRA } from './desert-chain-1.js';
export const IDRIS = { mob: 'camel-driver', biome: 'desert' };
/**
 * The desert's branch of the camels (ADR 0047): Kassim's lost caravan left
 * no camel by its wreck, because they bolted north to the camel drivers'
 * relay, out on the road to the capital. Idris gathers his herd back with the
 * player's help and gives one of his camels for it, a little quicker than
 * the capital's horse.
 */
export const DESERT_CAMEL_QUESTS = [
    {
        id: 'desert-relay',
        name: 'Le relais des chameliers',
        biome: 'desert',
        level: 13,
        requires: ['desert-wreck'],
        giver: ZAHRA,
        turnIn: IDRIS,
        offer: 'Il n’y avait pas de chameaux près des chariots, mais j’ai trouvé leurs traces. Elles partent vers le nord, vers le relais des chameliers, sur la route de Havrebourg. Un chameau rentre toujours chez lui ! Va voir Idris, le chamelier.',
        summary: 'Suivre les traces des chameaux jusqu’au relais des chameliers, au nord de Sablerouge, et parler au Chamelier Idris.',
        pending: 'Le relais est au nord, sur la route de Havrebourg. Cherche une grande tente rayée, avec des chameaux autour, et Idris qui leur parle.',
        complete: 'Doucement, Safran, c’est un ami ! Tu viens pour la caravane de Kassim ? Trois de ses chameaux sont rentrés cette nuit, tout griffés. Les autres sont encore perdus dans les dunes. J’espère que les hyènes ne les ont pas eus.',
        objectives: [
            {
                kind: 'reach',
                label: 'Atteindre le relais des chameliers',
                landmark: 'Relais des chameliers',
            },
        ],
        reward: { xp: 200, gold: 40 },
    },
    {
        id: 'desert-strays',
        name: 'Les bêtes égarées',
        biome: 'desert',
        level: 13,
        requires: ['desert-relay'],
        giver: IDRIS,
        turnIn: IDRIS,
        offer: 'Mes chameaux ne rentreront pas tant que les hyènes les poursuivent. Elles les poussent vers leur grotte comme un troupeau ! Chasse les hyènes, et les scorpions aussi : un chameau piqué ne se relève pas. Mes bêtes trouveront le chemin toutes seules.',
        summary: 'Chasser les hyènes et les scorpions qui traquent les chameaux égarés.',
        pending: 'Les hyènes sont partout dans les dunes, et les scorpions se cachent sous le sable. Regarde où tu marches !',
        complete: 'Tu entends ces clochettes ? Ils rentrent ! Un, deux, trois… sept ! Il n’en manque plus que deux. Et je sais qui les a.',
        objectives: [
            { kind: 'kill', label: 'Hyènes chassées', mobs: ['hyena'], count: 20 },
            { kind: 'kill', label: 'Scorpions géants abattus', mobs: ['scorpion'], count: 10 },
        ],
        reward: { xp: 500, gold: 100, items: [{ templateId: 'desert-tonic', quantity: 2 }] },
    },
    {
        id: 'desert-saddle',
        name: 'Une bosse pour la route',
        biome: 'desert',
        level: 14,
        requires: ['desert-strays'],
        giver: IDRIS,
        turnIn: IDRIS,
        offer: 'Les deux derniers chameaux, ce sont les momies qui les ont ! Elles les obligent à tirer leurs chariots, les pauvres bêtes. Bats ces momies et rapporte-moi six de leurs bandages, ça fait de très bonnes sangles. Et j’ai une belle selle pour qui me ramène mes bêtes !',
        summary: 'Abattre des momies pour libérer les deux derniers chameaux, et rapporter leurs bandelettes à Idris.',
        pending: 'Les momies traînent près des tombes, à l’ouest. Il me faut six bandages. Propres, si possible. Enfin, pas trop sales.',
        complete: 'Ils sont tous rentrés ! Kassim ne va pas me croire. Tiens, je te présente Datte. C’est ma chamelle la plus rapide : elle court plus vite qu’un cheval et ne boit qu’une fois par semaine. Par contre, elle crache. Pas sur toi. Enfin, pas souvent.',
        objectives: [
            { kind: 'kill', label: 'Momies abattues', mobs: ['mummy'], count: 12 },
            { kind: 'collect', label: 'Bandelettes', item: 'mummy-wrap', count: 6 },
        ],
        reward: { xp: 600, gold: 120, items: [{ templateId: 'desert-camel', quantity: 1 }] },
    },
];
//# sourceMappingURL=desert-camels.js.map